import Helper from './Helper';

class setBackgroundImage {
  constructor(config = {}) {
    const {
      imageContainerSelector,
      isPDF
    } = config;

    this.imageContainer = document.querySelectorAll(imageContainerSelector);
    this.imageContainerArray = Array.prototype.slice.call(this.imageContainer);
    this.isPDF = isPDF || false;

    if(this.imageContainer){
      this.imageContainerArray.forEach(container => {
        this.addBackgroundImages(container);
      });
    }
  }

  addBackgroundImages(imageContainer){
    const img = imageContainer.querySelector('img');
    if(img.src){
      imageContainer.style.backgroundImage = `url(${img.src})`;
    } else {
      imageContainer.style.backgroundImage = `url(${img.getAttribute('data-src')})`;
    }
    Helper.addClass(img, 'sr');
    if(this.isPDF){
      const quoteHeight = imageContainer.nextElementSibling.offsetHeight;
      // console.log(quoteHeight);
      imageContainer.style.height = quoteHeight;
    }
  }

} export default setBackgroundImage;
